<template>
  <div class="show">
    <div class="diseases_box" v-show="this.$route.query.id=='1'">
      <div class="diseases_top">
        <div class="diseases_top_img">
          <img src="../../assets/images/home/ceshi2.jpeg" alt="">
          <div>哮喘</div>
        </div>
        <div class="diseases_top_text">
          <div class="title">简介</div>
          <div class="content">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et
            justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et
            justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et</div>
        </div>
      </div>
      <div class="mask"></div>
      <div class="diseases_center">
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
        <div class="center_list">
          <div class="item_listTop">
            <img src="../../assets/images/home/u3309.png" alt="">
            <div>病因</div>
          </div>
          <div class="item_listText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et </div>
        </div>
      </div>
    </div>
    <div class="video_box" v-show="this.$route.query.id=='2'">
      <div class="KpVideo_Card_list">
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
        <div class="item_Card_list">
          <div class="card_img">
            <img src="../../assets/images/home/ceshi1.jpeg" alt="">
            <div>怎么直观排除还是不是自</div>
          </div>
          <div class="card_name">
            <div>张毅</div>
            <span>北京协和医院副主任医师</span>
          </div>
        </div>
      </div>
    </div>
    <div class="text_box" v-show="this.$route.query.id=='3'">
      <div class="card_leftList_centre">
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <div>Q</div>
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <div>A</div>
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <div>Q</div>
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <div>A</div>
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <div>Q</div>
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <div>A</div>
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <div>Q</div>
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <div>A</div>
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <div>Q</div>
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <div>A</div>
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="voice_box" v-show="this.$route.query.id=='4'">
      <div class="voice_list">
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_top">
            <img src="../../assets/images/home/ceshi2.jpeg" alt="">
            <div class="item_top_center">
              <div>王五</div>
              <span>主任医生</span>
            </div>
          </div>
          <div class="item_bottom">
            <div class="voice_title">疫情期间产检怎么做</div>
            <div class="audio_box">
              <!--<audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">-->
              <!--</audio>-->
              <Audio :styles="{width:'189px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="answer_box" v-show="this.$route.query.id=='5'">
      <div class="card_leftList_centre">
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item_List">
          <div class="list_twoBox">
            <div class="list_twoBox_Q">
              <span>小孩蛀牙吃什么药效果好？</span>
            </div>
            <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
            </div>
            <div class="list_twoBox_bottom">
              <div class="doctor_head">
                <img src="../../assets/images/home/ceshi2.jpeg" alt="">
                <div class="doctor_name">张三三</div>
                <div class="doctor_hospital">北京协和医院</div>
                <div class="doctor_twoTitle">儿科医院</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="recommend_box" v-show="this.$route.query.id=='6'">
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>
      <div class="swiper_listBox">
        <!--上-->
        <div class="slide_top">
          <img src="../../assets/images/home/ceshi1.jpeg" alt="">
        </div>
        <!--中-->
        <div class="slide_center">
          <div class="user_name">
            <div>张三三</div>
            <span>主任医师</span>
          </div>
          <div class="user_title">
            <div>北京协和医院</div>
            <span>呼吸内科主任</span>
          </div>
        </div>
        <!--下-->
        <div class="slide_bottom">
          <div class="top_box">
            <div class="video">
              <img width="24px" height="20px" src="../../assets/images/home/u4279.png" alt="">
              <div class="title">视频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="voice">
              <img width="24" height="23px" src="../../assets/images/home/u10222.png" alt="">
              <div class="title">音频</div>
              <div class="num">28</div>
            </div>
            <div class="mask"></div>
            <div class="text">
              <img width="19px" height="20px"  src="../../assets/images/home/u4294.png" alt="">
              <div class="title">文章</div>
              <div class="num">28</div>
            </div>
          </div>
          <div class="chaKan">查看</div>
        </div>
      </div>

    </div>
    <Pagination  :pageSize="pageSize" v-model="dataForm.page" @on-jump="jump" />
  </div>
</template>

<script>
  import Pagination from '../../components/pagination/index'
  import Audio from '../../components/audio/Index'
  export default {
    components:{
      Pagination,
      Audio
    },
    data() {
      return {
        xx:false,
        pageSize:10,
        dataForm:{
          page:1
        }
      }
    },
    methods:{
      jump(page){

      },
      getAudio(){
        let audios = document.getElementsByTagName("Audio");
        // 暂停函数
        function pauseAll() {
          var self = this;
          [].forEach.call(audios, function (i) {
            // 将audios中其他的audio全部暂停
            i !== self && i.pause();
          })
        }
        // 给play事件绑定暂停函数
        [].forEach.call(audios, function (i) {
          i.addEventListener("play", pauseAll.bind(i));
        })
      }
    },
    mounted() {
      this.getAudio()
    }
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .show{
    // 疾病百科
    .diseases_box{
      .diseases_top{
        display flex
        .diseases_top_img{
          position relative
          margin-right 20px
          >img{
            width: 243px;
            height: 141px;
          }
          >div{
            position: absolute;
            left: 0;
            top: 50%;
            width: 243px;
            height: 59px;
            font-weight: 700;
            font-style: normal;
            font-size: 28px;
            color: #333
            text-align: center
            line-height 59px
            background rgba(255,255,255,0.6)
            transform translateY(-50%)
          }
        }
        .diseases_top_text{
          flex 1
          .title{
            width: 140px;
            height: 35px;
            border-radius: 5px;
            background #1083f8
            color: #fff
            font-weight: 700;
            font-size: 16px;
            text-align: center
            line-height:35px
            margin-bottom 20px
          }
          .content{
            font-size: 14px;
            line-height: 22px;
            color: #333
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
          }
        }
      }
      .mask{
        width: 100%
        height: 1px
        border-top 1px solid #eee
        margin-top 20px
      }
      .diseases_center{
        margin-top 20px
        .center_list{
          margin-bottom 50px
          .item_listTop{
            display flex
            align-items center
            margin-right 20px
            >img{
              max-width: 25px
              max-height 22px
              margin-right 20px
            }
            >div{
              font-weight: 700;
              font-size: 18px;
              color: #63A3FC;
            }
          }
          .item_listText{
            margin-top 30px
            color: #333333;
            font-size: 14px;
            line-height: 22px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    // 相关视频
    .video_box{
      .KpVideo_Card_list{
        display flex
        flex-wrap wrap
        .item_Card_list{
          width: 224px;
          height: 225px;
          display flex
          flex-direction column
          justify-content space-between
          padding-bottom 20px
          margin-bottom 20px
          margin-right 20px
          cursor: pointer
          &:nth-child(4n){
            margin-right 0px
          }
          &:hover{
            box-shadow:0px 2px 6px 1px #999;
          }
          .card_img{
            display flex
            flex-direction column
            >img{
              width: 224px
              height: 120px
            }
            >div{
              margin-top 15px
              padding 0 15px
              font-size: 16px;
              color: #5E5E5E;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              line-height 20px
            }
            &:after{
              content ''
              width 100%
              height 1px
              border-top:1px dashed  #eee
              margin-top 5px
            }
          }

          .card_name{
            padding 0 15px
            display flex
            justify-content space-between
            align-items center
            >div{
              width 30%
              font-weight: 700;
              font-style: normal;
              font-size: 14px;
              color: #5E5E5E;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            >span{
              display block
              font-size: 12px;
              color: #5E5E5E;
              width 70%
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: right
            }
          }
        }
      }
    }
    // 相关文章
    .text_box{
      .card_leftList_centre{
        .item_List{
          margin-bottom 25px
          &:after{
            content ''
            display block
            width: 100%
            height: 1px
            border-top 1px dashed #eee
            margin-top 15px
          }
          .list_twoBox{
            .list_twoBox_Q{
              display flex
              align-items center
              >div{
                width: 40px
                height: 40px
                border-radius: 5px;
                background #63a3fc
                font-weight: 700;
                font-style: normal;
                font-size: 20px;
                color: #fff
                text-align: center
                line-height:40px
                margin-right 20px
              }
              >span {
                font-weight: 700;
                font-style: normal;
                font-size: 16px;
                color: #333
                cursor: pointer
              }
            }
            .list_twoBox_A{
              margin-top 20px
              display flex
              align-items center
              >div{
                width: 40px
                height: 40px
                border-radius: 5px;
                background #f57a7c
                font-weight: 700;
                font-style: normal;
                font-size: 20px;
                color: #fff
                text-align: center
                line-height:40px
                margin-right 20px
              }
              >span {
                width 95%
                font-style: normal;
                color: #333
                font-size: 14px;
                line-height: 22px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            }
            .list_twoBox_bottom{
              display flex
              align-items center
              .doctor_head{
                display flex
                align-items center
                margin-top 20px
                >img{
                  width: 60px;
                  height: 60px;
                  border-radius 50%
                  margin-right 15px
                }
                .doctor_name{
                  font-weight: 700;
                  font-style: normal;
                  font-size: 14px;
                  color: #5E5E5E;
                  margin-right 15px
                  max-width: 90px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .doctor_hospital{
                  font-size: 14px;
                  color: #5E5E5E;
                  margin-right 15px
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width 150px
                }
                .doctor_twoTitle{
                  font-size: 14px;
                  color: #5E5E5E;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width 150px
                }
              }
            }
          }
        }
      }
    }
    // 相关语音
    .voice_box{
      .voice_list{
        display flex
        flex-wrap wrap
        .item{
          margin-right 45px
          width: 224px;
          height: 284px;
          border 1px solid #8cd4a7
          border-radius: 7px;
          padding 10px 0
          margin-bottom 30px
          &:nth-child(4n){
            margin-right 0
          }
          .item_top{
            display flex
            flex-direction column
            align-items center
            &:after{
              content ''
              display block
              width: 100%
              height: 1px
              border-top 1px dashed #eee
              margin-top 15px
            }
            >img{
              width: 135px;
              height: 135px;
              border-radius 50%
            }
            .item_top_center{
              width: 80%
              display flex
              justify-content space-around
              align-items center
              margin-top 10px
              >div{
                max-width 60px
                font-weight: 700;
                font-style: normal;
                font-size: 18px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              >span{
                display block
                max-width 70px
                font-size: 14px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .item_bottom{
            display flex
            flex-direction column
            align-items center
            .voice_title{
              max-width 200px
              margin-top 10px
              font-size: 16px;
              color: #333
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .audio_box{
              margin-top 10px
              >audio{
                width: 200px;
                height: 35px;
                outline none
              }
            }
          }
        }
      }
    }
    // 相关问答
    .answer_box{
      .card_leftList_centre{
        .item_List{
          margin-bottom 25px
          &:after{
            content ''
            display block
            width: 100%
            height: 1px
            border-top 1px dashed #eee
            margin-top 15px
          }
          .list_twoBox{
            .list_twoBox_Q{
              display flex
              align-items center
              >div{
                width: 40px
                height: 40px
                border-radius: 5px;
                background #63a3fc
                font-weight: 700;
                font-style: normal;
                font-size: 20px;
                color: #fff
                text-align: center
                line-height:40px
                margin-right 20px
              }
              >span {
                font-weight: 700;
                font-style: normal;
                font-size: 16px;
                color: #333
                cursor: pointer
              }
            }
            .list_twoBox_A{
              margin-top 20px
              display flex
              align-items center
              >div{
                width: 40px
                height: 40px
                border-radius: 5px;
                background #f57a7c
                font-weight: 700;
                font-style: normal;
                font-size: 20px;
                color: #fff
                text-align: center
                line-height:40px
                margin-right 20px
              }
              >span {
                width 95%
                font-style: normal;
                color: #333
                font-size: 14px;
                line-height: 22px;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
              }
            }
            .list_twoBox_bottom{
              display flex
              align-items center
              .doctor_head{
                display flex
                align-items center
                margin-top 20px
                >img{
                  width: 60px;
                  height: 60px;
                  border-radius 50%
                  margin-right 15px
                }
                .doctor_name{
                  font-weight: 700;
                  font-style: normal;
                  font-size: 14px;
                  color: #5E5E5E;
                  margin-right 15px
                  max-width: 90px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .doctor_hospital{
                  font-size: 14px;
                  color: #5E5E5E;
                  margin-right 15px
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width 150px
                }
                .doctor_twoTitle{
                  font-size: 14px;
                  color: #5E5E5E;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width 150px
                }
              }
            }
          }
        }
      }
    }
    // 专家推荐
    .recommend_box{
      display flex
      flex-wrap wrap
      margin-bottom 30px
      .swiper_listBox{
        margin-right 20px
        margin-bottom 20px
        width: 245px;
        height: 473px;
        display flex
        flex-direction column
        align-items center
        justify-content space-around
        border:1px solid #e4e4e4
        border-radius: 7px;
        &:nth-child(4n){
          margin-right 0px
        }
        &:hover{
          border-color: #1083f8
        }
        .slide_top{
          width: 200px
          height: 200px
          background #f2f2f2
          border-radius 50%
          display flex
          align-items center
          justify-content center
          >img{
            width: 180px
            height: 180px
            border-radius 50%
          }
        }
        .slide_center{
          display flex
          flex-direction column
          align-items center
          &:after{
            content:''
            display block
            width: 100%
            height: 1px
            border-top:1px solid #eee
            margin 20px 0
          }
          .user_name{
            /*margin-top 10px*/
            display flex
            align-items center
            >div{
              font-weight: 700;
              font-size: 18px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width 65px
              margin-right 10px
            }
            >span{
              font-size: 16px;
              color #fff
              width: 85px;
              height: 31px;
              background #1083f8
              display block
              text-align: center
              line-height 31px
              border-radius: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .user_title{
            margin-top 20px
            display flex
            align-items center
            >div{
              width: 100px
              font-size: 14px;
              color: #000000;
              padding-right 10px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            >span{
              width: 100px
              display block
              font-size: 14px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .slide_bottom{
          .top_box{
            display flex
            align-items center
            justify-content space-between
            width: 200px
            margin-bottom 20px
            .video,.voice,.text{
              display flex
              flex-direction column
              align-items center
              >img{

              }
              .title{
                font-size: 16px;
                color: #A1A1A1;
                margin 10px 0 5px 0
              }
              .num{
                font-size: 18px;
                color: #8CD4A7;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width 50px
              }
            }
            .mask{
              height: 60px
              width: 1px
              background #eee
            }
          }
          .chaKan{
            margin 0 auto
            width: 68px;
            height: 25px;
            border 1px solid #199ed8
            color: #199ed8
            border-radius: 5px;
            text-align: center
            line-height 25px
            cursor: pointer
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/diseaseLibrary/DIseaseShow.vue